import React, { useEffect, useState } from 'react'
import axiosInstance from '../../../hooks/axiosInstance'
import { toast } from 'react-toastify'

const EditDues = ({ close, refreshPage, currentDue }) => {
    const [loading, setLoading] = useState()
    const [formData, setFormData] = useState({
        name: '',
        type: '',
        startDate: '',
        endDate: '',
        amount: '',
        description: '',
        status: ''
    })

    const handleChange = (e) => {
        const {name, value} = e.target

        setFormData(prevFormData => (
            {...prevFormData, [name]: value}
        ))
    }

    const handleSubmit = (e) => {
        e.preventDefault()

        setLoading(true)
        axiosInstance.put(`/association/dues/${currentDue.id}`, formData)
            .then(res => {
                toast.success(res.data.message)
                refreshPage()
                close()
            })
            .catch(err => {
                console.log(err.response);
                toast.error("An error occured. Please, try again")
            })
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        setFormData({
            name: currentDue?.name,
            type: currentDue?.type,
            startDate: currentDue?.start_date,
            endDate: currentDue?.end_date,
            amount: currentDue?.amount,
            description: currentDue?.description,
            status: currentDue?.status
        })
    }, [currentDue])
    
  return (
    <div>
        <form onSubmit={handleSubmit}>
            <div className="row g-3">
                <div className="col-lg-12">
                    <div>
                        <label for="company_name-field" className="form-label">Name</label>
                        <input 
                            type="text" 
                            className="form-control" 
                            placeholder="Enter name" required
                            name='name'
                            value={formData.name} 
                            onChange={handleChange}
                        />
                    </div>
                </div>
                {/* <!--end col--> */}
                <div className="col-lg-12">
                    <div>
                        <label for="leads_score-field" className="form-label">Type</label>
                        <select className="form-control" name='type' value={formData.type} onChange={handleChange}>
                            <option value="">--Select--</option>
                            <option value="recurrent">Recurrent</option>
                            <option value="one_off">One Off</option>
                        </select>
                    </div>
                </div>
                {/* <!--end col--> */}
                {formData.type == 'recurrent' &&
                    <>
                        <div className="col-lg-6">
                            <div>
                                <label className="form-label">Start Date</label>
                                <input 
                                    type="date" 
                                    className="form-control" 
                                    placeholder="Enter name" required
                                    name='startDate'
                                    value={formData.startDate} 
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div>
                                <label className="form-label">End Date</label>
                                <input 
                                    type="date" 
                                    className="form-control" 
                                    placeholder="Enter name" required
                                    name='endDate'
                                    value={formData.endDate} 
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </>
                }
                {/* <!--end col--> */}
                <div className="col-lg-12">
                    <div>
                        <label className="form-label">Amount (₦)</label>
                        <input 
                            type="text" 
                            className="form-control" 
                            placeholder="Enter Amount" 
                            required
                            name='amount'
                            value={formData.amount}
                            onChange={handleChange}
                        />
                    </div>
                </div>
                {/* <!--end col--> */}
                <div className="col-lg-12">
                    <div>
                        <label className="form-label">Description</label>
                        <textarea 
                            className="form-control" 
                            rows="3"
                            name='description'
                            value={formData.description}
                            onChange={handleChange}
                        ></textarea>
                    </div>
                </div>
                {/* <!--end col--> */}
                <div className="col-lg-12">
                    <div>
                        <label  className="form-label">Status</label>
                        <select 
                            className="form-control" 
                            name="status"
                            value={formData.status}
                            onChange={handleChange}
                        >
                            <option value="">--Select--</option>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                        </select>
                    </div>
                </div>
            </div>
            <div className='mt-4'>
                <div className="hstack gap-2 justify-content-end">
                    <button type="button" className="btn btn-light" onClick={close}>Close</button>
                    <button 
                        type="submit" 
                        className="btn btn-success"
                        disabled={loading}
                    >{loading ? <div className="spinner-border spinner-border-sm text-light"></div> : 'Update Due'}</button>
                </div>
            </div>
        </form>
    </div>
  )
}

export default EditDues
